var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlateInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 1.66602V14.166V18.3327H18.2492C17.197 19.3637 15.7561 19.9993 14.1667 19.9993C12.5772 19.9993 11.1363 19.3637 10.0842 18.3327H0V4.29759L2.5 1.66602H20ZM8.53743 15.7011C8.40436 15.212 8.33333 14.6973 8.33333 14.166C8.33333 13.7912 8.36868 13.4247 8.43623 13.0695H6.66667V15.7011H8.53743ZM9.07624 11.3151C9.1056 11.2628 9.13575 11.211 9.16667 11.1597V8.68356H6.66667V11.3151H9.07624ZM10.8333 9.37826C11.2433 9.09227 11.6918 8.8576 12.1694 8.68356H10.8333V9.37826ZM16.1639 8.68356C16.6415 8.8576 17.09 9.09227 17.5 9.37826V8.68356H16.1639ZM2.5 4.29759H5V6.92917H2.5V4.29759ZM6.66667 4.29759H9.16667V6.92917H6.66667V4.29759ZM13.3333 4.29759H10.8333V6.92917H13.3333V4.29759ZM15 4.29759H17.5V6.92917H15V4.29759ZM2.5 8.68356H5V11.3151H2.5V8.68356ZM5 13.0695H2.5V15.7011H5V13.0695ZM19 14.166C19 16.8354 16.836 18.9993 14.1667 18.9993C11.4973 18.9993 9.33333 16.8354 9.33333 14.166C9.33333 11.4966 11.4973 9.33268 14.1667 9.33268C16.836 9.33268 19 11.4966 19 14.166ZM15 10.8327V12.4993H13.3333V10.8327H15ZM15 17.4993V13.3327H13.3333V17.4993H15Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlateInfo);
export default __webpack_public_path__ + "static/media/PlateInfo.08981d33c1f8c12c202e39b5033bc0fe.svg";
export { ForwardRef as ReactComponent };